import type React from 'react'
import { NodeActionsContext, type NodeActionsContextValue } from './NodeActionsContextDef'

/**
 * Provider component for NodeActionsContext
 */
export const NodeActionsProvider: React.FC<{
  value: NodeActionsContextValue
  children: React.ReactNode
}> = ({ value, children }) => (
  <NodeActionsContext.Provider value={value}>{children}</NodeActionsContext.Provider>
)
